import { keyframes } from 'styled-components';

export const pulse = keyframes`
  from {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  to {
    transform: scale(1);
  }
`;

/* This is a custom ease to mimic a spring/bounce: */
export const bounceLikeEasing = 'cubic-bezier(0.515, 0.615, 0.085, 1)';
